import { render, staticRenderFns } from "./MyChoresScreen.vue?vue&type=template&id=23bbabea&scoped=true"
import script from "./MyChoresScreen.vue?vue&type=script&lang=js"
export * from "./MyChoresScreen.vue?vue&type=script&lang=js"
import style0 from "./MyChoresScreen.vue?vue&type=style&index=0&id=23bbabea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bbabea",
  null
  
)

export default component.exports